module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "subreason-form",
    attrs: {
      "resource": _vm.config.api + '/subreason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "subreason-grid",
    attrs: {
      "resource": _vm.config.api + '/subreason_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Submotivos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642c8a86"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-subreason.vue
// module id = 165
// module chunks = 0